
















































































import { Vue, Component, Emit, Prop } from 'vue-property-decorator'
import { SpringExam } from '@/models/springexam/SpringExam'
import { randKey } from '@/utils/random'

@Component
export default class ExamDetail extends Vue {
  @Prop({ type: Object, required: true }) form!: SpringExam
  randKey = randKey()

  formateSwitch(celValue: boolean) {
    if (celValue) {
      return '是'
    } else return '否'
  }

  @Emit('clickReturn')
  onReturn($event: any) {
    this.form = {
      name: '',
      explain: '',
      examProjects: [],
      examUsers: []
    }
    return $event
  }
}
